// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";import * as Sentry from '@sentry/nextjs';

const SENTRY_ENVIRONMENT = process.env.VERCEL_ENV || 'localhost';

Sentry.init({
	dsn: 'https://931d38e8918f45af9c9041b1452142c9@o431005.ingest.us.sentry.io/6052364',

	// Add optional integrations for additional features
	integrations: [
		Sentry.replayIntegration(),
		Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })
	],

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: 1,

	// Define how likely Replay events are sampled.
	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// Define how likely Replay events are sampled when an error occurs.
	replaysOnErrorSampleRate: 1.0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: false,

	environment: SENTRY_ENVIRONMENT
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
